// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__IFmZz","actions":"GroupTable_actions__Wlo1I","deleteModalFooter":"GroupTable_deleteModalFooter__fLSeX"};